import React from 'react';
import { Link } from 'react-router-dom';
import './StoreUnavailablePage.css';

export default function StoreUnavailablePage() {
  return (
    <section className="store-unavailable-page">
      <div className="store-unavailable-container">
        <div className="store-unavailable-icon">
          <i className="mdi mdi-store-off"></i>
        </div>
        <h1 className="store-unavailable-title">Under Renovation</h1>
        <p className="store-unavailable-description">
          The store is currently unavailable as we make some renovations!
        </p>
        <Link to="/" className="btn btn-primary btn-large">
          Go Home
        </Link>
      </div>
    </section>
  );
}
